export default "__VITE_ASSET__CIfDQvmM__"